// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cfu-zone {
  position: relative;
  width: 100%;
  border: var(--cui-border-width) dashed var(--cui-border);
  border-radius: var(--cui-radius);
  background: var(--cui-bg-subtle);
  color: var(--cui-text-muted);
  cursor: pointer;
  outline: none;
  transition: border-color var(--cui-transition), background var(--cui-transition),
    box-shadow var(--cui-transition);
}

.cfu-zone:hover:not(.cfu-disabled):not(.cfu-error) {
  border-color: var(--cui-primary);
  background: var(--cui-primary-soft);
}

.cfu-zone:focus-visible {
  border-color: var(--cui-primary);
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

.cfu-dragOver {
  border-style: solid;
  border-color: var(--cui-primary);
  background: var(--cui-primary-soft);
}

/* A chosen file gets a solid border like the other controls */
.cfu-hasFile {
  border-style: solid;
  background: var(--cui-bg);
}

/* Error: red border */
.cfu-error,
.cfu-error:hover {
  border-color: var(--cui-danger);
  background: var(--cui-danger-soft);
}

.cfu-error:focus-visible {
  box-shadow: 0 0 0 3px var(--cui-danger-ring);
}

.cfu-disabled {
  background: var(--cui-bg-disabled);
  cursor: not-allowed;
  opacity: 0.7;
}

/* ---------- empty state ---------- */
.cfu-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 14px;
  text-align: center;
}

.cfu-compact .cfu-empty {
  flex-direction: row;
  justify-content: flex-start;
  min-height: var(--cui-control-height);
  padding: 6px 12px;
  text-align: left;
}

.cfu-uploadIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: var(--cui-primary-soft);
  color: var(--cui-primary);
  flex-shrink: 0;
}

.cfu-compact .cfu-uploadIcon {
  width: 28px;
  height: 28px;
}

.cfu-error .cfu-uploadIcon {
  background: var(--cui-danger-soft-hover);
  color: var(--cui-danger);
}

.cfu-emptyText {
  font-size: var(--cui-font-size);
}

.cfu-emptyText strong {
  color: var(--cui-primary);
  font-weight: 600;
}

/* ---------- chosen file ---------- */
.cfu-file {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 10px 12px;
}

.cfu-thumb {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  object-fit: cover;
  border: 1px solid var(--cui-border-soft);
  border-radius: var(--cui-radius-sm);
  background: var(--cui-bg-subtle);
}

.cfu-compact .cfu-thumb {
  width: 32px;
  height: 32px;
}

.cfu-fileIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: var(--cui-radius-sm);
  background: var(--cui-primary-soft);
  color: var(--cui-primary);
}

.cfu-fileMeta {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}

.cfu-fileName {
  overflow: hidden;
  color: var(--cui-text);
  font-size: var(--cui-font-size);
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cfu-fileSub {
  color: var(--cui-text-muted);
  font-size: var(--cui-font-size-sm);
}

.cfu-fileActions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  color: var(--cui-text-muted);
}

.cfu-iconBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 0;
  border-radius: var(--cui-radius-sm);
  background: transparent;
  color: var(--cui-text-muted);
  cursor: pointer;
  transition: background var(--cui-transition), color var(--cui-transition);
}

.cfu-iconBtn:hover {
  background: var(--cui-bg-hover);
  color: var(--cui-text);
}

.cfu-removeBtn:hover {
  background: var(--cui-danger-soft);
  color: var(--cui-danger);
}

.cfu-spin {
  color: var(--cui-primary);
  animation: cfu-spin 0.8s linear infinite;
}

@keyframes cfu-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomFileUpload/CustomFileUpload.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,wDAAwD;EACxD,gCAAgC;EAChC,gCAAgC;EAChC,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb;oCACkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;;EAEE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,wCAAwC;EACxC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mCAAmC;EACnC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mCAAmC;EACnC,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".cfu-zone {\n  position: relative;\n  width: 100%;\n  border: var(--cui-border-width) dashed var(--cui-border);\n  border-radius: var(--cui-radius);\n  background: var(--cui-bg-subtle);\n  color: var(--cui-text-muted);\n  cursor: pointer;\n  outline: none;\n  transition: border-color var(--cui-transition), background var(--cui-transition),\n    box-shadow var(--cui-transition);\n}\n\n.cfu-zone:hover:not(.cfu-disabled):not(.cfu-error) {\n  border-color: var(--cui-primary);\n  background: var(--cui-primary-soft);\n}\n\n.cfu-zone:focus-visible {\n  border-color: var(--cui-primary);\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n.cfu-dragOver {\n  border-style: solid;\n  border-color: var(--cui-primary);\n  background: var(--cui-primary-soft);\n}\n\n/* A chosen file gets a solid border like the other controls */\n.cfu-hasFile {\n  border-style: solid;\n  background: var(--cui-bg);\n}\n\n/* Error: red border */\n.cfu-error,\n.cfu-error:hover {\n  border-color: var(--cui-danger);\n  background: var(--cui-danger-soft);\n}\n\n.cfu-error:focus-visible {\n  box-shadow: 0 0 0 3px var(--cui-danger-ring);\n}\n\n.cfu-disabled {\n  background: var(--cui-bg-disabled);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* ---------- empty state ---------- */\n.cfu-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 20px 14px;\n  text-align: center;\n}\n\n.cfu-compact .cfu-empty {\n  flex-direction: row;\n  justify-content: flex-start;\n  min-height: var(--cui-control-height);\n  padding: 6px 12px;\n  text-align: left;\n}\n\n.cfu-uploadIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: var(--cui-primary-soft);\n  color: var(--cui-primary);\n  flex-shrink: 0;\n}\n\n.cfu-compact .cfu-uploadIcon {\n  width: 28px;\n  height: 28px;\n}\n\n.cfu-error .cfu-uploadIcon {\n  background: var(--cui-danger-soft-hover);\n  color: var(--cui-danger);\n}\n\n.cfu-emptyText {\n  font-size: var(--cui-font-size);\n}\n\n.cfu-emptyText strong {\n  color: var(--cui-primary);\n  font-weight: 600;\n}\n\n/* ---------- chosen file ---------- */\n.cfu-file {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  padding: 10px 12px;\n}\n\n.cfu-thumb {\n  width: 48px;\n  height: 48px;\n  flex-shrink: 0;\n  object-fit: cover;\n  border: 1px solid var(--cui-border-soft);\n  border-radius: var(--cui-radius-sm);\n  background: var(--cui-bg-subtle);\n}\n\n.cfu-compact .cfu-thumb {\n  width: 32px;\n  height: 32px;\n}\n\n.cfu-fileIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: var(--cui-radius-sm);\n  background: var(--cui-primary-soft);\n  color: var(--cui-primary);\n}\n\n.cfu-fileMeta {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.cfu-fileName {\n  overflow: hidden;\n  color: var(--cui-text);\n  font-size: var(--cui-font-size);\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cfu-fileSub {\n  color: var(--cui-text-muted);\n  font-size: var(--cui-font-size-sm);\n}\n\n.cfu-fileActions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  color: var(--cui-text-muted);\n}\n\n.cfu-iconBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: 0;\n  border-radius: var(--cui-radius-sm);\n  background: transparent;\n  color: var(--cui-text-muted);\n  cursor: pointer;\n  transition: background var(--cui-transition), color var(--cui-transition);\n}\n\n.cfu-iconBtn:hover {\n  background: var(--cui-bg-hover);\n  color: var(--cui-text);\n}\n\n.cfu-removeBtn:hover {\n  background: var(--cui-danger-soft);\n  color: var(--cui-danger);\n}\n\n.cfu-spin {\n  color: var(--cui-primary);\n  animation: cfu-spin 0.8s linear infinite;\n}\n\n@keyframes cfu-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
